import Fuse from "fuse.js";
import type { FuseResult, IFuseOptions } from "fuse.js";

export interface FilterOption {
  value: string;
  label: string;
}

const keys: (keyof FilterOption)[] = ["value"];

// TODO 56455: refactor fuzzy search with ApiSearchBar and BmuFuzzySearchBar
export const fuzzyFilter = (
  allOptions: FilterOption[],
  filterString: string
): FilterOption[] => {
  if (!filterString) {
    return allOptions;
  }

  const config: IFuseOptions<FilterOption> = {
    /**
     * Note on threshold: this mainly affects the scoring algorithm and the output score (see https://www.fusejs.io/concepts/scoring-theory.html).
     * It also seems to somewhat filters the results, but not to the same actual threshold; there will be results with a score > 0.2 in the output.
     * Through testing, 0.2 seems to be about right, where lots of relevant results are included.
     */
    threshold: 0.2,
    includeMatches: true, // This will allow for future highlighting of matches within the data (e.g. in bold in the Figma designs)
    ignoreLocation: true, // Default is to match from the start, we don't care where the search result appears and want a substring match
    keys,
  };

  const fuse = new Fuse(allOptions, config);
  return fuse
    .search(filterString)
    .map((result: FuseResult<FilterOption>) => result.item);
};

export const convertToOption = (s: string): FilterOption => ({
  value: s,
  label: s,
});

export const mapToOptions = (values: string[]): FilterOption[] =>
  values.map(convertToOption);
